export default __webpack_public_path__ + "static/media/img1.6e01b792.gif";